<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_temp_list" v-if="!loading && section">
        <div class="pa-1">
          <v-card class="rounded_max mb-2" elevation="1">
            <div class="d-flex justify-space-between px-2">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    :to="`/section/inclass/${$route.params.idSection}/${$route.params.idCourse}`"
                    icon
                    ><v-icon>mdi-reply</v-icon></v-btn
                  >
                </template>
                <span>Back</span>
              </v-tooltip>
              <h3 class="mb-2">Group Project</h3>
              <div v-if="readonly" class="mx-5"></div>

              <v-btn
                v-if="!readonly"
                icon
                color="red"
                @click="deleteModule($route.params.idModule)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
            <v-tabs
              centered
              :color="section.color"
              slider-size="4"
              v-model="tab"
            >
              <v-tab class="text-capitalize" v-if="!isEmpty">
                <b>Response</b>
              </v-tab>
              <v-tab class="text-capitalize"> <b>Module</b> </v-tab>
            </v-tabs>
          </v-card>
        </div>

        <v-tabs-items v-model="tab" style="background: none">
          <v-tab-item class="pa-1" v-if="!isEmpty">
            <result-group-project @empty="checkData" :color="section.color" />
          </v-tab-item>
          <v-tab-item class="pa-1">
            <div>
              <v-card
                class="rounded_max"
                elevation="1"
                style="overflow: hidden"
              >
                <div class="strip" :style="`background:${section.color}`"></div>

                <div class="px-5" v-if="dataSet.data">
                  <p class="default_txt mt-2">Module Title</p>
                  <v-text-field
                    :disabled="readonly"
                    placeholder="Type Here"
                    hide-details
                    v-model="dataSet.data.title"
                    @blur="updateDataModule"
                    :color="section.color"
                    style="font-size: 30px"
                    class="ma-0 pa-0"
                  ></v-text-field>
                  <p class="default_txt mt-5">Description</p>
                  <vue-editor
                    v-if="!readonly"
                    v-model="dataSet.data.description"
                    placeholder="Type Here"
                    :editor-toolbar="customToolbar"
                    @blur="updateModule"
                  />
                  <v-card class="pa-3" outlined v-else>
                    <p
                      class="mb-0"
                      v-html="
                        dataSet.data.description.replaceAll(/\n/g, '<br />')
                      "
                    ></p>
                  </v-card>
                  <!-- <v-textarea
                    :disabled="readonly"
                    dense
                    placeholder="Type Here"
                    v-model="dataSet.data.description"
                    hide-details
                    @blur="updateDataModule"
                    rows="2"
                    auto-grow
                    :color="section.color"
                  ></v-textarea> -->
                  <p class="default_txt mt-5">Due Date</p>
                  <v-menu
                    :disabled="readonly"
                    v-model="calendar"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        placeholder="Click here"
                        append-icon="mdi-calendar"
                        :disabled="readonly"
                        readonly
                        v-model="detail.due"
                        v-bind="attrs"
                        v-on="on"
                        hide-details
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="detail.due"
                      @change="updateDataModule"
                      @input="calendar = false"
                      :min="$date().add(1, 'day').format('YYYY-MM-DD')"
                    ></v-date-picker>
                  </v-menu>
                  <p class="default_txt mt-5">Project Group detail</p>
                  <div
                    class="mt-1"
                    style="color: rgba(0, 0, 0, 0.4)"
                    v-if="readonly"
                    v-html="detail.about"
                  ></div>
                  <vue-editor
                    v-if="!readonly"
                    placeholder="Content"
                    @blur="updateDataModule"
                    v-model="detail.about"
                    :editorToolbar="customToolbar"
                    id="editor2"
                    class="my-3"
                  ></vue-editor>
                </div>
                <div class="pa-2 d-flex justify-end">
                  <p class="default_txt">{{ msg }}</p>
                </div>
              </v-card>
              <div>
                <v-card class="rounded_max pa-3 mt-3" elevation="1">
                  <h2>Link For Project</h2>
                  <div class="my-2">
                    <p class="ma-0">Link Proposal</p>
                    <v-btn
                      depressed
                      class="btn my-2"
                      v-if="readonly"
                      :href="detail.link_proposal"
                      target="_blank"
                    >
                      Link Proposal
                    </v-btn>
                    <v-textarea
                      v-if="!readonly"
                      dense
                      placeholder="Put the link here"
                      v-model="detail.link_proposal"
                      hide-details
                      @blur="updateDataModule"
                      rows="4"
                      outlined
                      class="rounded_max"
                      auto-grow
                      :color="section.color"
                    ></v-textarea>
                  </div>
                  <div class="my-2">
                    <p class="ma-0">Link Progress Report</p>
                    <v-btn
                      depressed
                      class="btn my-2"
                      v-if="readonly"
                      :href="detail.link_progress"
                      target="_blank"
                    >
                      Link Progress Report
                    </v-btn>
                    <v-textarea
                      v-if="!readonly"
                      dense
                      placeholder="Put the link here"
                      v-model="detail.link_progress"
                      hide-details
                      rows="4"
                      @blur="updateDataModule"
                      outlined
                      :disabled="readonly ? true : saving ? true : false"
                      class="rounded_max"
                      auto-grow
                      :color="section.color"
                    ></v-textarea>
                  </div>
                  <div class="my-2">
                    <p class="ma-0">Link Final Report</p>
                    <v-btn
                      depressed
                      class="btn my-2"
                      v-if="readonly"
                      :href="detail.link_finish"
                      target="_blank"
                    >
                      Link Final Report
                    </v-btn>
                    <v-textarea
                      v-if="!readonly"
                      dense
                      placeholder="Put the link here"
                      v-model="detail.link_finish"
                      hide-details
                      @blur="updateDataModule"
                      :disabled="readonly ? true : saving ? true : false"
                      rows="4"
                      outlined
                      class="rounded_max"
                      auto-grow
                      :color="section.color"
                    ></v-textarea>
                  </div>
                </v-card>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <div v-if="loading" class="_temp_list">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="pb-3">
              <v-skeleton-loader
                type="article"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="list-item-avatar-three-line"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="image"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="list-item-three-line"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>

    <div class="pa-3">
      <v-snackbar v-model="saving" left :timeout="-1">
        {{ msg }}
      </v-snackbar>
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
// import DialogMedium from "../../../dialog/dialogMedium.vue";
import DialogSmall from "../../../dialog/dialogSmall.vue";
import ResultGroupProject from "../response/resultGroupProject.vue";
export default {
  components: {
    // DialogMedium,
    DialogSmall,
    ResultGroupProject,
  },
  name: "moduleGroupProject",
  props: ["readonly"],

  data() {
    return {
      loading: true,
      dataSet: null,
      detail: null,
      section: null,
      msg: "",
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      isUpdate: false,
      updating: false,
      saving: false,
      err: "",
      selectedGb: null,
      tab: null,
      calendar: null,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        ["link"],
        [{ color: [] }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      ],
      isEmpty: false,
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.fetchData();
    },
  },
  mounted() {
    this.fetchSection();
  },
  methods: {
    checkData(val) {
      this.isEmpty = val;
    },
    fetchSection() {
      this.loading = true;
      let data = {
        path: `manage/course/section?filter[id]=${this.$route.params.idSection}`,
      };
      this.$store.dispatch("course/getData", data).then((data) => {
        this.loading = false;
        this.section = data.data[0];
        this.fetchData(true);
      });
    },
    fetchData(first) {
      let module = this.$route.params.idModule;
      let instance = this.$route.params.idInstance;
      if (first) {
        this.loading = true;
      }
      let data = {
        path: `manage/course/section/module/${module}/${instance}`,
      };
      this.$store.dispatch("course/getData", data).then((data) => {
        this.dataSet = data;
        if (data.detail.length) {
          this.detail = data.detail[0];
          if (this.detail.deadline) {
            this.detail["due"] = this.$date(this.detail.deadline).format(
              "YYYY-MM-DD",
            );
          } else {
            this.detail["due"] = null;
          }
          this.loading = false;
        } else {
          this.createDataModule();
        }
      });
    },

    deleteModule() {
      this.d_type = "d_module";
      this.d_title = "Delete Module";
      this.inventory = this.dataSet;
      this.d_small = true;
    },
    updateModule() {
      this.msg = "saving..";
      let body = {
        course_materi_id: this.dataSet.data.id,
        title: this.dataSet.data.title,
        description: this.dataSet.data.description,
      };
      let data = {
        path: `manage/material/update-detail`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then(() => {
          this.msg = "";
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
        })
        .catch((err) => {
          this.msg = "Error";
        });
    },
    createDataModule() {
      this.msg = "Saving...";
      let body = {
        course_group_project_id: this.dataSet.data.id,
        title: this.dataSet.data.title,
        description: this.dataSet.data.description,
        link_proposal: "",
        link_progress: "",
        link_finish: "",
      };
      let data = {
        path: `manage/course/project-assignment/group/update/detail`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then(() => {
          this.fetchData(true);
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    updateDataModule() {
      this.saving = true;
      this.msg = "Saving...";
      let body = {
        course_group_project_id: this.dataSet.data.id,
        title: this.dataSet.data.title,
        description: this.dataSet.data.description,
        about: this.detail.about,
        deadline: this.detail.due,
        link_proposal: this.detail.link_proposal,
        link_progress: this.detail.link_progress,
        link_finish: this.detail.link_finish,
      };
      let data = {
        path: `manage/course/project-assignment/group/update/detail`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then(() => {
          this.msg = "Saved";
          setTimeout(() => {
            this.saving = false;
          }, 800);
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.msg = "Error";
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.strip {
  padding: 3px;
  height: 10px;
  width: 100%;
  border-radius: 0 !important;
}
.card_gb {
  position: relative;
  overflow: hidden;
}
.icon_gb {
  position: absolute;
  right: -20px;
  bottom: -20px;
}
</style>
